import { Component } from '@angular/core';
import { LeaveService } from '../../services/leave/leave.service';
import { ToastService } from '../../services/toast.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-approval',
  templateUrl: './approval.component.html',
  styleUrl: './approval.component.scss',
})
export class ApprovalComponent {
  comment: string = '';
  action: string = '';
  token: string = '';
  requestId: string = '';
  approver: string = '';
  hideSubmitButton: boolean = false;
  constructor(
    private readonly leaveService: LeaveService,
    private readonly toast: ToastService,
    private readonly route: ActivatedRoute,
    private router:Router
  ) {
    this.route.params.subscribe((params) => {
      this.requestId = params['id'];
    });

    this.route.queryParams.subscribe((params) => {
      this.action = params['action'];
      this.token = params['token'];
      this.approver = params['approver'];
    });
  }
  submit() {
    const trimmedComment = this.comment?.trim() || '';
    const isApproval = this.action.toLowerCase() === 'approve';
    const actionType = isApproval ? 'approved' : 'rejected';

    if (!isApproval && !trimmedComment) {
      this.toast.failure('Please Enter Comments.');
      return;
    }

    const payload = {
      status: actionType,
      comments: trimmedComment,
      token: this.token,
      approverforMail: this.approver,
    };

    this.leaveService.mailApproveOrReject(payload, this.requestId).subscribe({
      next: (resp) => {
        this.toast.success(resp.message);
        this.hideSubmitButton = true;
      },
      error: (err) => {
        this.toast.failure(err.error.message);
        this.router.navigateByUrl('/app/login', { skipLocationChange: true });
      },
    });
  }
}
